module.exports = __webpack_public_path__ + "static/media/YF64_0.dd0001e7.jpg";